interface V3IconMessageProps extends React.SVGProps<SVGSVGElement> {
    stroke?: string;
}

export const V3IconMessage = ({ stroke = "#ABB0BA", ...rest }: V3IconMessageProps) => <svg width="16" height="16" {...rest} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.667 3.333H3.333C2.597 3.333 2 3.93 2 4.667v6.666c0 .737.597 1.334 1.333 1.334h9.334c.736 0 1.333-.597 1.333-1.334V4.667c0-.737-.597-1.334-1.333-1.334Z" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="m2 4.667 6 4 6-4" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
</svg>
